import { crc16 } from 'crc'
import { every, first, get, isEqual, isObjectLike, size, split } from 'lodash'
import React, { Fragment, ReactNode } from 'react'

export { default as defaultHeaders } from './defaultHeaders'
export { default as request } from './request'
export { default as toast } from './toast'
export { default as sleep } from './sleep'
export { default as arraySlicer } from './arraySlicer'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function isStringDeepEqual(value: any, otherValue: any): boolean {
  let result
  if (isObjectLike(value)) {
    result = every(value, (v, k) => isStringDeepEqual(v, get(otherValue, k)))
  } else {
    result =
      isEqual(value, otherValue) ||
      ((value === '' || value === null || value === undefined) &&
        (otherValue === '' || otherValue === null || otherValue === undefined))
  }
  return result
}

export function getBrowserLanguage(): string {
  const browserLanguage =
    get(navigator, 'language') || get(navigator, 'userLanguage')
  const arr = split(String(browserLanguage), '-')
  const detectedLanguage = first(arr) as string
  if (size(detectedLanguage) !== 2) {
    return 'de'
  }

  return detectedLanguage
}

export function relativeToAbsoluteUrl(relativeUrl: string): string {
  return `${location.protocol}//${location.hostname}${
    location.port ? ':' + location.port : ''
  }${relativeUrl}`
}

export function checksum(v: unknown): number {
  return crc16(String(v))
}

export const isNotNull = <T>(value: T | null): value is T => value !== null

export const isValidReactNode = (value: unknown): value is ReactNode => {
  // checks for simple types and React elements
  if (
    value === null ||
    typeof value === 'boolean' ||
    typeof value === 'number' ||
    typeof value === 'string' ||
    React.isValidElement(value)
  ) {
    return true
  }

  // Check for React Fragments
  if (React.isValidElement(value) && value.type === Fragment) {
    return true
  }

  if (Array.isArray(value)) {
    return value.every(isValidReactNode)
  }

  console.warn('Encountered an unusual ReactNode', new Error().stack)
  return true
}
